import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA — register the service worker so Chrome (desktop + Android) surfaces
// the "Install app" prompt on hifireels.com. Guarded so we don't try in
// preview environments where the SW file might return non-JS.
if ("serviceWorker" in navigator && window.location.protocol === "https:") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => { /* ignore */ });
  });
}

// Stale-build guard (support #274116) - runs once when the app starts.
// After a redeploy a phone can still be running an OLD JS bundle (cached app
// shell / old service worker), so new fixes look "not deployed". Compare the
// bundle we are running with the one the server serves now; if they differ,
// drop the service-worker caches and reload ONCE. Only at startup, so a live
// stream or battle in progress is never interrupted.
if (window.location.protocol === "https:") {
  (async () => {
    try {
      const BUNDLE = /[/]static[/]js[/]main[.][a-z0-9]+[.]js/;
      const running = Array.from(document.scripts).map((s) => s.src).find((s) => BUNDLE.test(s));
      if (!running) return; // dev server / no hashed bundle
      const res = await fetch(`/?_v=${Date.now()}`, { cache: "no-store" });
      const html = await res.text();
      const m = html.match(BUNDLE);
      if (!m || running.endsWith(m[0])) return;
      if (sessionStorage.getItem("hf_stale_reload") === m[0]) return; // never loop
      sessionStorage.setItem("hf_stale_reload", m[0]);
      if ("serviceWorker" in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister()));
      }
      if (window.caches) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
      window.location.reload();
    } catch { /* never block the app */ }
  })();
}
